module.exports = __webpack_public_path__ + "img/horizontal_6_2_pp2_9005.b86e587f.png";